import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { FormikProvider, useFormik } from "formik";
import {
  OcCard,
  OcCardButtonBar,
  OcConfirmationDialog,
  OcSettingSwitchFormik,
} from "oc/components";
import useProperty from "oc/hooks/use-property";
import { useOcFormikHelper } from "oc/utils";

interface MyDocumentsSettingsCardProps {
  isMobile: boolean;
}

export const MyDocumentsSettingsCard = ({
  isMobile,
}: MyDocumentsSettingsCardProps) => {
  const { t } = useTranslation();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [enabledSave, setEnabledSave] = useState(true);

  /*
  const { setOpenMessage } = useOcSnackbar();
  const [updateProperty, { loading: updateLoading }] = useMutation(
    OC_UPDATE_PROPERTY,
    {
      onError({ ...err }) {
        alert("error" + err.toString());
        setOpenMessage({
          type: "error",
          message: t("OC_PROPERTY_SAVE_FAILED"),
        });
      },
      onCompleted(data) {
        if (data?.updateProperty.key === "myDocumentsMenuEnabled") {
          const parsedValue = data?.updateProperty.value === "true";
          setEnabledSave(parsedValue);
        }
        setOpenMessage({
          type: "success",
          message: t("OC_PROPERTY_SAVE_SUCCEEDED"),
        });
      },
    },
  );*/

  const { data, loading } = useProperty({
    resource: "myDocuments",
    key: "myDocumentsMenuEnabled",
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    // It needs to be converted to a boolean
    setEnabledSave(data === "true");
  }, [data]);

  const formik = useFormik({
    initialValues: {
      enabledSave: enabledSave,
    },
    onSubmit: () => {
      updateProperties();
    },
    enableReinitialize: true,
  });

  const { loadingState, updateProperties } = useOcFormikHelper({
    defaultResource: "myDocuments",
    formik,
    valuesExtraData: {
      enabledSave: {
        key: "myDocumentsMenuEnabled",
        loading,
        type: "switch",
        returnType: "boolean",
      },
    },
  });

  const handleSave = () => {
    setShowConfirmDialog(false);
    formik.submitForm();
  };

  const handleCancel = () => {
    formik.resetForm();
  };

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={handleSave}
        onCancel={handleDialogCancel}
        title={t("OC_CONFIRM_SETTING")}
        texts={[t("OC_CONFIRM_SETTING_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <OcCard label={t("OC_GENERAL_SETTINGS")} loading={loadingState}>
        <FormikProvider value={formik}>
          <Box height="10px" />
          <OcSettingSwitchFormik
            name="enabledSave"
            id="enabledSave"
            label={"MyDocuments"}
            info={t("MY_DOCUMENTS_MENU_ALLOWED_INFO")}
            disabled={loadingState}
            isMobile={isMobile}
          />
          <OcCardButtonBar
            handleRightButton={handleCancel}
            rightButtonText={t("OC_CANCEL")}
            rightButtonColor="secondary"
            handlePrimaryButton={() => setShowConfirmDialog(true)}
            primaryButtonText={t("OC_SAVE")}
            primaryButtonDisabled={!formik.dirty}
          />
        </FormikProvider>
      </OcCard>
    </>
  );
};

export default MyDocumentsSettingsCard;
